<template>
  <div>
    <div class="me-info">
      <ul class="me-info-items f-cbli">
        <li class="me-info-item">
          <div class="me-info-name">输入原密码</div>
          <div class="me-info-input">
            <input type="password" v-model="origin"/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">输入新密码</div>
          <div class="me-info-input">
            <input type="password" v-model="password"/>
          </div>
        </li>
        <li class="me-info-item">
          <div class="me-info-name">确认新密码</div>
          <div class="me-info-input">
            <input type="password" v-model="passwordConfirm"/>
          </div>
        </li>
      </ul>
      <div class="modify-warn">*密码长度为10-15位，支持数字、字母、下划线</div>
      <div class="me-info-button">
        <button type="button" @click="modifyPassword">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "modify-password",
    data(){
      return{
        origin:"",
        password:"",
        passwordConfirm:""
      }
    },
    methods:{
      modifyPassword(){
        this.$api.get("",{
          api:"/v1/passport/edit_psd",
          old_pass:this.origin,
          new_pass:this.password,
          confirm_pass:this.passwordConfirm,
          user_type:this.tools.getCookie("user_type")
        },res=>{
          if(res.status===1){;
            this.$toast("修改成功");
          }
        })
      }
    }
  }
</script>

<style scoped>
  .me-info-item{
    height:1.68rem;
    margin:0 0.4rem;
    border-bottom:1px solid #e6e6e6;
    display: flex;
    justify-content: space-between;
  }
  /*.me-info-item:after{*/
    /*content: "";*/
    /*display: block;*/
    /*clear: both;*/
  /*}*/
  .me-info-name{
    /*float: left;*/
    color:#333;
    font-size: 0.426rem;
    line-height: 1.68rem;
    flex-shrink: 0;
  }
  .me-info-input{
    /*float:right;*/
  }
  .me-info-input input{
    width:7.066rem;
    height:1.68rem;
    border:0;
    font-size: 0.426rem;
    color:#999;
    text-align: right;
    background:#f2f2f2;
  }
  .me-info-select{
    line-height: 1.68rem;
  }
  .me-info-input select{
    margin-left: 0.4rem;
    width:2.533rem;
    height:0.8rem;
    background:#f2f2f2;
  }
  .me-info-avatar{
    position: relative;
    float:right;
    overflow: hidden;
    margin-top:0.2rem;
    width:1.306rem;
    height:1.306rem;
    border-radius: 50%;
  }
  .me-info-avatar-upload{
    position: absolute;
    top:0;
    left:0;
    width:1.306rem;
    height:1.306rem;
    opacity: 0;
  }
  .me-info-button{
    margin-top:0.666rem;
    text-align: center;
  }
  .me-info-button button{
    width:1.76rem;
    height:0.96rem;
    background:#EC6D3A;
    text-align: center;
    color:#fff;
    border:0;
    font-size: 0.426rem;
    border-radius: 0.133rem;
  }
  .modify-warn{
    margin:0.4rem;
    color:#999;
    font-size:0.347rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/modify-password/modify-password.vue